import React from "react";
import ComingSoon from "./DataScience/ComingSoon";
const DataScienceMain = () => {
  return (
    <div>   
        <ComingSoon />
    </div>
    );
};

export default DataScienceMain;